import { isEmpty, omit } from 'lodash';
import { schema } from 'normalizr';

const assignee = new schema.Entity(
  'assignees',
  {},
  {
    idAttribute: (assignee) => assignee?.assigneeId?._id,
    processStrategy: (assignee) =>
      omit(
        {
          ...(assignee || {}),
          ...(assignee?.assigneeId || {}),
        },
        'assigneeId',
      ),
  },
);

const subtaskAssignee = new schema.Entity(
  'assignees',
  {},
  {
    idAttribute: (assignee) => assignee?.assigneeId,
  },
);

const user = new schema.Entity(
  'users',
  {},
  {
    idAttribute: (creator) => (typeof creator === 'string' ? creator : creator?._id),
  },
);

const dashboardTask = new schema.Entity(
  'tasks',
  {},
  {
    idAttribute: '_id',
    processStrategy: (entity) => omit(entity, ['projects']),
  },
);

const subtask = new schema.Entity(
  'subtasks',
  {
    assignee: [subtaskAssignee],
  },
  {
    idAttribute: '_id',
  },
);

const allTasksEntity = new schema.Entity(
  'tasks',
  {
    assignee: [assignee],
    subtasks: [subtask]
  },
  {
    idAttribute: '_id',
    processStrategy: (entity) => ({
      ...omit(entity, ['projects', 'files']),
      projectAndSectionLabelList: (entity?.projects || []).reduce(
        (result, project) => {
          if (!project?.projectId) return result;
          return ({
            ...result,
            [project?.projectId]: {
              archived: project?.archived,
              projectId: project?.projectId,
              deprecated_projectTitle: project?.projectTitle, // TODO: [new tasks store] needs to be taken from projects entities which is not yet implemented
              sectionId: project?.sectionId,
              deprecated_sectionTitle: project?.sectionTitle, // TODO: [new tasks store] needs to be taken from projects entities which is not yet implemented
            },
          });
        },
        {},
      ),
    }),
  },
);

const boardTasksEntity = new schema.Entity(
  'tasks',
  {
    assignee: [assignee],
    subtasks: [subtask]
  },
  {
    idAttribute: '_id',
    processStrategy: (entity) => ({
      ...omit(entity, ['projects', 'customFields']),
      extendedCustomFields: entity?.customFields,
    }),
  },
);

const addedTask = new schema.Entity(
  'tasks',
  {
    subtasks: [subtask]
  },
  {
    idAttribute: '_id',
    processStrategy: (entity) => omit(entity, ['projects', 'customFields']),
  },
);

const task = new schema.Entity(
  'tasks',
  {
    assignee: [assignee],
    createdBy: user,
    subtasks: [subtask]
  },
  {
    idAttribute: '_id',
    processStrategy: (task) => {
      const sortedCustomFields = task?.customFields?.sort((fieldA, fieldB) => {
        if (fieldA.name < fieldB.name) {
          return -1;
        }
        if (fieldA.name > fieldB.name) {
          return 1;
        }
        return 0;
      });

      let projectAndSectionLabelList = {};

      if (!isEmpty(task?.projects)) {
        projectAndSectionLabelList = (task?.projects || []).reduce(
          (result, project) => {
            if (!project?.project?._id) return result;
            return ({
              ...result,
              [project?.project?._id]: {
                archived: project?.archived,
                projectId: project?.project?._id,
                deprecated_projectTitle: project?.project?.title, // TODO: [new tasks store] components should take titles from projects entities store which is not yet implemented
                sectionId: project?.section?._id,
                deprecated_sectionTitle: project?.section?.title, // TODO: [new tasks store] components should take titles from projects entities store which is not yet implemented
              },
            });
          },
          {},
        )
      } else {
        projectAndSectionLabelList = !task?.projectId ? {} : {
          [task?.projectId]: {
            projectId: task?.projectId,
            sectionId: task?.sectionId,
          }
        }
      }

      return ({
      ...omit(task, ['projects', 'customFields']),
      extendedCustomFields: sortedCustomFields,
      projectAndSectionLabelList,
    })},
  },
);

const section = new schema.Entity(
  'sections',
  {},
  {
    idAttribute: 'sectionId',
    mergeStrategy: (entityA, entityB) => {
      return {
        tasks: [...entityA.tasks, ...entityB.tasks],
      };
    },
    processStrategy: entity => ({ tasks: [entity?._id] })
  },
);

const schemas = {
  GET_WORKSPACE_TASKS_SCHEMA: { tasks: [dashboardTask] },
  GET_ALL_TASKS_SCHEMA: { tasks: [allTasksEntity] },
  GET_BOARD_TASKS_SCHEMA: { tasks: [boardTasksEntity] },
  GET_TASK_SCHEMA: { data: task },
  ADD_TASK_EVENT_SCHEMA: { data: addedTask },
  GET_SECTION_TASKS_SCHEMA: { data: [task] },
  TASKS_BY_SECTION_ID_SCHEMA: { tasks: [section] },
};

export default schemas;
